import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { authApi } from "@/lib/auth";
import { storage } from "@/lib/storage";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    const role = sessionStorage.getItem("opg_pending_role") || "merchant";
    authApi
      .exchange(sessionId)
      .then(({ data }) => {
        storage.setUser(data);
        toast.success(`Welcome, ${data.name || data.email}`);
        if (!storage.hasPin()) navigate("/pin-setup", { replace: true });
        else {
          sessionStorage.removeItem("opg_pending_role");
          navigate(`/unlock?role=${role}`, { replace: true });
        }
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/", { replace: true });
      });
  }, [hash, navigate]);

  return (
    <div className="page-shell flex items-center justify-center min-h-screen" data-testid="auth-callback">
      <Logo size={54} />
    </div>
  );
}
